module.exports = __webpack_public_path__ + "media/images/new_home/share-white-c9ee1463f7024813431e8c91e0b53fd1.png";